export const measurementUnitList = [
  { value: 'metric', label: 'metric' },
  { value: 'imperial', label: 'imperial' },
  { value: 'us imperial', label: 'us imperial' },
];
